const map = {
	"./2025NSW_ banner.jpg": 17046,
	"./2026NSW_banner.jpg": 55615,
	"./4529194-2.png": 99239,
	"./7952884--3.png": 92696,
	"./7952884--3BG.png": 43717,
	"./Banner_NYP_Closing_2025.jpg": 9346,
	"./Banner_NYSP_2024.jpg": 23906,
	"./Banner_NYSP_2025.jpg": 15615,
	"./Customized-Partnerships.png": 58553,
	"./DST-logo-old.png": 46907,
	"./DST-logo.jpg": 69947,
	"./DST-logo.png": 89923,
	"./DSTI-logo.png": 72420,
	"./Group-160.png": 1567,
	"./Mask-Group-3.png": 44466,
	"./NSW banner.jpg": 41130,
	"./NYS-initiative.jpg": 3629,
	"./NYS-initiative2.png": 64699,
	"./NYS-logo-with-background.png": 99204,
	"./NYS-logo-without-background.png": 53088,
	"./Rectangle 288.png": 21543,
	"./Science.png": 31368,
	"./Search": 34145,
	"./Search.json": 34145,
	"./analysis.png": 86470,
	"./approval-icon.png": 40779,
	"./assaf.webp": 14032,
	"./attendance-summary.svg": 66844,
	"./background.png": 39528,
	"./banner3y.png": 51194,
	"./banner_NSW2024.jpg": 1527,
	"./baseline-account_circle-24px.png": 23741,
	"./baseline-place-24px.png": 79448,
	"./bg-project-apply.png": 6590,
	"./bullet.png": 90276,
	"./cancel-icon.png": 18850,
	"./carousel2.jpg": 13266,
	"./carousel3.jpg": 89647,
	"./check-mark.png": 226,
	"./checklist.jpg": 51558,
	"./cit-sci-yellow.png": 27869,
	"./citizen science 3-3.png": 2371,
	"./citizen science landing.png": 33617,
	"./citizen-science-programme.png": 83894,
	"./contract.png": 35238,
	"./csir-logo.png": 47771,
	"./csir.webp": 14663,
	"./cv.png": 91323,
	"./documents-required.jpg": 17480,
	"./dsi.webp": 102,
	"./event-app.png": 73000,
	"./event-background.png": 75029,
	"./event-background@2x.png": 17951,
	"./event-location.svg": 81006,
	"./event-programme-yel.png": 25866,
	"./event-programme.png": 94347,
	"./events-app.png": 28389,
	"./events-app2x.png": 60803,
	"./exibit.png": 79445,
	"./faq.png": 34478,
	"./folder.png": 78280,
	"./get_involved.jpg": 19162,
	"./google-play.png": 4394,
	"./graphic.png": 81086,
	"./group-attendees.svg": 45517,
	"./hand-coin.png": 78161,
	"./hsrc.webp": 77576,
	"./icon-avatar.png": 54341,
	"./icon-building.png": 73686,
	"./icon-bus.png": 11194,
	"./icon-calendar.png": 29232,
	"./icon-location.png": 87919,
	"./icon-person.png": 62641,
	"./icon-reports.png": 213,
	"./icon-wifi.png": 77777,
	"./image.png": 78369,
	"./individual-attendees.svg": 39805,
	"./innovation-icon.png": 4303,
	"./join-p-b-2.png": 2271,
	"./join-p-b.png": 51422,
	"./learning.png": 94270,
	"./location-icon.png": 21611,
	"./login-illustration.png": 44286,
	"./mail.png": 37605,
	"./manage-events.png": 79303,
	"./manage-events.svg": 53159,
	"./math-icon.png": 38390,
	"./megaphone.png": 29372,
	"./mentor.png": 74699,
	"./need-help.png": 64438,
	"./no-results.jpg": 23812,
	"./nrf.webp": 31376,
	"./nsw.jpg": 94946,
	"./nys-programme-yel.png": 62396,
	"./nys-programme.png": 3677,
	"./offline-capabilities.svg": 26546,
	"./parnerships-active.png": 24832,
	"./parnerships-foreign.png": 788,
	"./parnerships-local.png": 13070,
	"./parnerships-private.png": 48829,
	"./parnerships-public.png": 74333,
	"./pdf.png": 72752,
	"./phone.png": 62978,
	"./project-1-1.png": 27729,
	"./project-1.png": 39607,
	"./project-2-1.png": 66,
	"./project-2.png": 32028,
	"./project_icon.png": 57129,
	"./questions.png": 31033,
	"./robot-icon.png": 16710,
	"./robotics.jpg": 53327,
	"./role-model.png": 46356,
	"./saasta-logo.png": 14209,
	"./saasta.png": 38737,
	"./sacnasp.png": 71279,
	"./sacnasp.webp": 10389,
	"./sacnasp2.webp": 1013,
	"./sansa.webp": 84572,
	"./science-icon.png": 31052,
	"./scientists-programme.png": 68076,
	"./seims-logo.png": 98111,
	"./shutter-icon.png": 95887,
	"./slider-bg.png": 38059,
	"./solidarity.png": 1732,
	"./stemi.jpg": 74946,
	"./t&c.png": 73523,
	"./teach.png": 28889,
	"./tia.webp": 91932,
	"./twitter.png": 52131,
	"./user.png": 94441,
	"./userGuide.png": 85049,
	"./userGuide@2x.png": 22139,
	"./volunteer-b.png": 45689,
	"./volunteer-graphic-edits.png": 99543,
	"./volunteer-y.png": 44090
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;